<template>
  <div>
    <form @submit.prevent="submitProduct">
      <v-row>
        <v-col
          cols="12"
          md="8"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>General</div>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-text-field
                    v-model="form.name"
                    hide-details="auto"
                    label="Product Name"
                    outlined
                    dense
                    clearable
                    :error-messages="errors.getMessage('name')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.barcode"
                    hide-details="auto"
                    label="Barcode"
                    outlined
                    dense
                    clearable
                    counter
                    :error-messages="errors.getMessage('barcode')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-autocomplete
                    v-model="form.category_id"
                    hide-details="auto"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    outlined
                    label="Category"
                    chips
                    clearable
                    :error-messages="errors.getMessage('category_id')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            class="mt-5"
            outlined
          >
            <!-- For Service type product -->
            <template v-if="form.type == 'Service'">
              <v-card-text>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="form.price"
                    hide-details="auto"
                    label="Service Charges"
                    outlined
                    dense
                    clearable
                    type="number"
                    :error-messages="errors.getMessage('price')"
                  />
                </v-col>
              </v-card-text>
            </template>
            <!-- end -->

            <!-- For standard type (None stackable) -->
            <template v-else>
              <v-card-text>
                <v-tabs centered>
                  <v-tab>Sell on basic (No purchase stock)</v-tab>
                  <v-tab>Plan to purchase stock</v-tab>
                  <v-tab-item class="mt-3">
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.qty"
                          hide-details="auto"
                          label="Product QTY"
                          outlined
                          dense
                          clearable
                          type="number"
                          :disabled="hasStock"
                          :error-messages="errors.getMessage('qty')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.cost"
                          hide-details="auto"
                          label="Product Cost"
                          outlined
                          :disabled="hasStock"
                          dense
                          clearable
                          type="number"
                          :error-messages="errors.getMessage('cost')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.price"
                          hide-details="auto"
                          :disabled="hasStock"
                          label="Product Price"
                          outlined
                          dense
                          clearable
                          type="number"
                          :error-messages="errors.getMessage('price')"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item class="mt-3">
                    <template v-if="hasStock">
                      <p class="pl-5">
                        <strong>Attention : </strong> Product cost,price and
                        quantity indexing according to purchase stock for
                        selling.
                      </p>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                Warehouse
                              </th>
                              <th class="text-left">
                                Qty
                              </th>
                              <th class="text-left">
                                Sold
                              </th>
                              <th class="text-left">
                                Cost
                              </th>
                              <th class="text-left">
                                Price
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in stocks"
                              :key="item.id"
                            >
                              <td>
                                {{ item.warehouse.name | capitalize }}
                              </td>
                              <td>{{ item.quantity }}</td>
                              <td>{{ item.sold }}</td>
                              <td>{{ item.cost | currency }}</td>
                              <td>{{ item.price | currency }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </template>
                    <template v-else>
                      <p>
                        <strong>Note :</strong> The Cost, Price and Quantity for
                        the product will be update automatically on purchase
                        with selected supplier(s).
                      </p>
                    </template>
                  </v-tab-item>
                </v-tabs>

                <!-- For Combo product type -->
                <template v-if="form.type == 'Combo'">
                  <div>Product variants</div>
                  <form @submit.prevent="addVariants">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="child.variant"
                          hide-details="auto"
                          label="Variant"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="child.price"
                          hide-details="auto"
                          label="Price Addtion"
                          outlined
                          type="number"
                          dense
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-btn
                          type="submit"
                          color="info"
                          :disabled="!child.variant || !child.price"
                        >
                          <v-icon>
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </form>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left" />
                          <th class="text-left">
                            Variant
                          </th>
                          <th class="text-left">
                            Extra Amount
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  color="grey lighten-1"
                                  v-on="on"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>
                                Extra amount will add to standard price. for
                                example : Actual amount {{ "5" | currency }} +
                                Extra Variant amount:{{ "2" | currency }} = Sale
                                Price :{{ "7" | currency }}
                              </span>
                            </v-tooltip>
                          </th>
                          <th>Sale Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in variants"
                          :key="item.variant"
                        >
                          <td>
                            <v-icon
                              color="error"
                              small
                              @click="removeChild(item)"
                            >
                              mdi-delete
                            </v-icon>
                            <v-icon
                              color="info"
                              small
                              @click="editChild(item)"
                            >
                              mdi-pencil
                            </v-icon>
                          </td>
                          <td>{{ form.name }}({{ item.variant }})</td>
                          <td>{{ item.price | currency }}</td>
                          <td>
                            {{ form.price | currency }}+{{
                              item.price | currency
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <!-- end -->
              </v-card-text>
            </template>
            <!-- end -->
          </v-card>
          <!-- end -->

          <v-card
            class="mt-5"
            outlined
          >
            <v-card-text>
              <div>Description</div>
              <v-row>
                <v-col cols="12">
                  <wysiwyg v-model="form.description" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>Properties</div>

              <v-col
                cols="12"
                md="12"
              >
                <v-autocomplete
                  v-model="form.suppliers"
                  :items="suppliers"
                  item-text="firstName"
                  item-value="id"
                  outlined
                  label="Suppliers"
                  multiple
                  chips
                  clearable
                  placeholder="Leave blank if no supplier"
                  :error-messages="errors.getMessage('suppliers')"
                />
                <v-select
                  v-model="form.type"
                  :items="types"
                  outlined
                  label="Type"
                  chips
                />

                <v-autocomplete
                  v-model="form.warehouseSaleFrom"
                  label="Sale From Warehouse"
                  :items="warehouses"
                  item-value="id"
                  item-text="name"
                  outlined
                  clearable
                  :error-messages="errors.getMessage('warehouseSaleFrom')"
                />

                <v-autocomplete
                  v-model="form.unitOfMeasure"
                  :items="uom"
                  outlined
                  hide-details="auto"
                  label="Uint of measure"
                  clearable
                />
              </v-col>
            </v-card-text>
          </v-card>
          <v-card
            class="mt-3"
            outlined
          >
            <v-card-text>
              <div>Extras</div>
              <v-col>
                <v-text-field
                  v-model="form.imei"
                  hide-details="auto"
                  label="IMEI"
                  outlined
                  dense
                  :error-messages="errors.getMessage('imei')"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="form.sNumber"
                  hide-details="auto"
                  label="Serial Number"
                  outlined
                  dense
                  :error-messages="errors.getMessage('sNumber')"
                />
              </v-col>
            </v-card-text>
          </v-card>
          <div class="text-center">
            <v-btn
              color="green"
              class="ma-2 white--text"
              type="submit"
            >
              Save
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              :to="{ name: 'Products' }"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      edit: false,
      types: ["Standard", "Combo", "Service"],
      variants: [],
      child: {},
      form: {
        type: "Standard",
        suppliers: [],
        qty: 0,
        price: 0,
        cost: 0,
        warehouseSaleFrom: 1,
      },
      categories: [],
      suppliers: [],
      warehouses: [],
      stocks: [],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      main: "configs/overall",
    }),

    hasStock() {
      return this.$data.stocks.length > 0;
    },
    uom() {
      const data = this.main.productUnits;
      if (data !== null) {
        return data.split(",");
      }
      return [];
    },
  },
  mounted() {
    this.getFromApi();
    if (this.$route.params.id) {
      window.axios.get("/product/" + this.$route.params.id).then((response) => {
        this.$data.form = response.data.product;
        this.$data.variants = response.data.product.variants;
        let suppliers = [];
        response.data.product.suppliers.forEach((supplier) => {
          suppliers.push(supplier.id);
        });
        this.$data.form.suppliers = suppliers;
        this.$data.stocks = response.data.stocks;
        this.$data.edit = true;
      });
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    redirect(response) {
      this.feedback(response.data.message);
      if (this.$route.params.id) {
        this.$router.replace({
          name: "ProductDetail",
          params: { id: this.$route.params.id },
        });
      } else {
        this.$router.replace({ name: "Products" });
      }
    },
    updateProduct() {
      let data = this.$data.form;
      window.axios.patch("/product/" + data.id, data).then((response) => {
        this.redirect(response);
      });
    },
    createProduct() {
      window.axios.post("/product", this.$data.form).then((response) => {
        this.redirect(response);
      });
    },
    submitProduct() {
      this.$data.form.variants = this.$data.variants;
      if (this.$data.edit) {
        this.updateProduct();
      } else {
        this.createProduct();
      }
    },
    editChild(item) {
      this.removeChild(item);
      this.$data.child = item;
    },
    removeChild(item) {
      let list = this.$data.variants;
      list.splice(list.indexOf(item), 1);
    },
    addVariants() {
      this.$data.variants.push(this.$data.child);
      this.$data.child = {};
    },
    getFromApi() {
      window.axios.get("/product-form-data").then((response) => {
        this.warehouses = response.data.warehouses;
        this.categories = response.data.categories;
        this.suppliers = response.data.suppliers;
      });
    },
  },
};
</script>
